import { ICadastralField, IErrors } from '../../../types/reducers/rosreestrData';
import { getError } from './getError';

interface IGetField {
  value: string;
  errors: IErrors;
  checkedValue?: string;
  isChecking: boolean;
  isRequired: boolean;
}

export const getField = ({ value, errors, checkedValue, isChecking, isRequired }: IGetField): ICadastralField => {
  return {
    value,
    error: getError(errors, value),
    isChecked: !!value && checkedValue === value,
    isChecking,
    isRequired,
  };
};
